module.exports = __webpack_public_path__ + "static/media/Banner Achs Virtual (1).53a39c84.png";